/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorDataModel } from '../../models/patient-behavior-data-model';

export interface GetPatientBehaviorData$Params {
  patientSessionID?: number;
}

export function GetPatientBehaviorData(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorData.PATH, 'get');
  if (params) {
    rb.query('patientSessionID', params.patientSessionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorDataModel>>;
    })
  );
}

GetPatientBehaviorData.PATH = '/api/Staff/GetPatientBehaviorData';
